module.exports = __webpack_public_path__ + "img/kubernetes-stacked-black.58987b71.svg";